import React, {  useState } from 'react'
import { Modal } from 'semantic-ui-react'
import classnames from 'classnames'


import CommonInput from '../common/CommonInput'
import CommonButton from './CommonButtons'


const IntegrationModal = ({
  modalImg,
  title,
  selectedData,
  id,
  connected,
  onClick
}) => {
  const [apiKey, SetApiKey] = useState('')
  const [modalOpen, setModalOpen] = useState(false)

  const handleOpen = () => {
    //setModalOpen(true)
    switch (id) {
      case 'zapier':
        window.open(
          'https://zapier.com/developer/invite/110618/2feca0d691d63f01a836e9cf7545740c/',
          '_blank'
        )
        break
      case 'googleManager':
        window.open(
          `https://accounts.google.com/o/oauth2/auth/oauthchooseaccount?response_type=code&access_type=offline&client_id=561194678958-bpdro47f9k0vub52o06rsiisqbqt2n8i.apps.googleusercontent.com&redirect_uri=${process.env.REACT_APP_ROOT_URL}/settings/integration/integration&state&scope=https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/analytics.edit https://www.googleapis.com/auth/analytics.manage.users https://www.googleapis.com/auth/analytics.provision&approval_prompt=force&flowName=GeneralOAuthFlow`,
          'rightFrame'
        )
        break
      case 'hubSpot':
        window.open(
          `https://app-eu1.hubspot.com/oauth/authorize?client_id=07261f2c-a2e2-45d6-957f-7df80c406694&redirect_uri=${process.env.REACT_APP_ROOT_URL}/hubspot-callback&scope=content timeline oauth integration-sync e-commerce crm.objects.contacts.read crm.objects.contacts.write`,
          '_blank'
        )
        break
      case 'slack':
        window.open(
          `https://slack.com/oauth/authorize?scope=channels:history,channels:read,channels:write,groups:history,groups:write,reactions:read,reactions:write,groups:read,chat:write:bot&client_id=${process.env.REACT_APP_SLACK_ID}&redirect_uri=${process.env.REACT_APP_ROOT_URL}/redirect-slack`,
          '_blank'
        )
        break
      case 'integromat':
        window.open(
          `https://www.integromat.com/en/apps/invite/f95fdc7e03e65d102392c16e613cdbe1`,
          '_blank'
        )
        break
      default:
        return
    }

   
  }

  const handleClose = () => setModalOpen(false)

  const onChangeApiKey = e => {
    const value = e.target.value
    SetApiKey(value)
  }

  

  const onClickSaveApi = () => {}
  return (
    <Modal
      dimmer="inverted"
      trigger={
        connected ? (
          <p
            onClick={onClick}
            name={id}
            className={classnames(`integration-status btn_disconnect`, {
              selectedIntegration: selectedData === id
            })}
          >
            Disconnect
          </p>
        ) : (
          <p
            onClick={handleOpen}
            name={id}
            className={classnames(`integration-status`, {
              selectedIntegration: selectedData === id
            })}
          >
            Connect
          </p>
        )
      }
      open={modalOpen}
      onClose={handleClose}
      className="modal-inverted-integration"
      closeIcon
    >
      <div className="integration-modal-wrapper">
        <h2 className="integration-modal-text">
          Allow {title} to access your LimePhone account.
        </h2>
        <div className="center-img">
          <img src={modalImg} alt="logo" />
        </div>
        <div className="integration-input-wrapper">
          <p className="api-text">
            API Key <span>(Required)</span>
          </p>
          <p className="integration-breadcrumb">
            Navigate to Settings  Installation  <span>API Keys</span> to
            generate your API Key.
          </p>

          <CommonInput
            onChange={onChangeApiKey}
            name="apiKey"
            type="text"
            background="gray"
            defaultValue={apiKey}
          />
        </div>

        <div className="integrate-wrapper">
          <CommonButton
            onClick={onClickSaveApi}
            content="Yes, Continue"
            background="blue"
            btnClass="btn-continue"
          />
          <CommonButton
            content="Cancel"
            background="blue"
            btnClass="btn-cancel"
            onClick={handleClose}
          />
        </div>
      </div>
    </Modal>
  )
}

export default IntegrationModal
